export default {
  ewd: [],
};
